import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchProjectdossierOrganisationLists,
  initialState,
} from '../services/fetchProjectdossierOrganisationLists'

export { useProjectdossierOrganisationLists }

const useProjectdossierOrganisationLists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchProjectdossierOrganisationLists,
    queryKey: ['valuelists-projectdossier', 'organisation'],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
